import { createContext, useContext } from 'react';
import { IPlatformContext } from '@vivli/core/infrastructure/interface';

export const PlatformContext = createContext<IPlatformContext>(null);

export const useActiveUserContext = () => useContext(PlatformContext).activeUser;
export const useExternalMenuItemsContext = () => useContext(PlatformContext).externalLinks;
export const useVivliConfigContext = () => useContext(PlatformContext).vivliConfig;
export const useUtilityApiContext = () => useContext(PlatformContext).utilityApi;
export const useAdminConsoleApiContext = () => useContext(PlatformContext).adminConsoleApi;
export const useChatApiContext = () => useContext(PlatformContext).chatApi;
export const useMetricsApiContext = () => useContext(PlatformContext).metricsApi;
export const useDataRequestsApiContext = () => useContext(PlatformContext).dataRequestsApi;
export const useMyDataRequestsApiContext = () => useContext(PlatformContext).myDataRequestsApi;
export const useOrganizationsApiContext = () => useContext(PlatformContext).organizationsApi;
export const useUsersApiContext = () => useContext(PlatformContext).usersApi;
export const useSearchApiContext = () => useContext(PlatformContext).searchApi;
export const useVocabSearchApiContext = () => useContext(PlatformContext).vocabSearchApi;
export const useQuickSearchApiContext = () => useContext(PlatformContext).quickSearchApi;
export const useOrcidApiContext = () => useContext(PlatformContext).orcidApi;
export const useStudiesApiContext = () => useContext(PlatformContext).studiesApi;
export const useDataPackageApiContext = () => useContext(PlatformContext).dataPackageApi;
export const useDataPackageFileApiContext = () => useContext(PlatformContext).dataPackageFileApi;
export const useListingRequestApiContext = () => useContext(PlatformContext).listingRequestApi;
export const useDisclosuresApiContext = () => useContext(PlatformContext).disclosuresApi;
export const useResultRequestApiContext = () => useContext(PlatformContext).resultRequestApi;
export const useVirtualMachineApiContext = () => useContext(PlatformContext).virtualMachineApi;
export const useCitationsApiContext = () => useContext(PlatformContext).citationsApi;
export const useNotificationApiContext = () => useContext(PlatformContext).notificationApi;
export const useEnquiryApiContext = () => useContext(PlatformContext).enquiryApi;
export const useDataRequestPermissionsContext = () => useContext(PlatformContext).dataRequestPermissions;
export const useDataRequestFiltersContext = () => useContext(PlatformContext).dataRequestFilters;
export const useDoiApiContext = () => useContext(PlatformContext).doiApi;
export const useCrossConcernsApiContext = () => useContext(PlatformContext).crossConcernsApi;
